export default {
    namespaced: true,
    state: () => ({
      showSuccessPopup: false,
    }),
    mutations: {
      SET_POPUP(state: any, payload: boolean) {
        state.showSuccessPopup = payload
      },
    },
    actions: {
      showPopup({ commit }: any) {
        commit('SET_POPUP', true)
      },
      hidePopup({ commit }: any) {
        commit('SET_POPUP', false)
      },
    },
  }
  